// extracted by mini-css-extract-plugin
export default {"root":"Locations-root-a745","header":"Locations-header-b812"};